import $ from 'jquery';
export class AddressConfirmationModal {
	/*element;
	backLink;
	confirmLink; */
	constructor(element) {
		this.element = element;
		this.backLink = this.element.find('a.back');
		this.confirmLink = this.element.find('a.confirm');
	}

    /**
     *
     * @param errors
     * @return {Promise<boolean>}
     */
	async open(errors) {
		this.backLink.unbind();
		this.confirmLink.unbind();
		
		const details = this.element.find('p.partialMatchSuggestion');
		details.empty();
		if (errors.message) {
			details.append(document.createTextNode(errors.message));
		}
		if (errors.suggestions && errors.suggestions.length) {
			details.append(' ');
			details.append(document.createTextNode(errors.suggestions.length > 1 ? 'Possible values: ' : 'Possible value: '));
			errors.suggestions.forEach((suggestion, index) => {
				if (index > 0) {
					details.append(document.createTextNode(', '));
				}
				details.append($('<strong></strong>').text(suggestion));
			});
		}
		
		return new Promise(function (resolve) {
			this.element.css('display', 'block');
			this.backLink.click(function (event) {
				try { gtag('event', 'AcceptAddressWarning', {'event_category': 'CheckoutSubmit'}); } catch(e) {}
				resolve(false);
			});
			this.confirmLink.click(function(event) {
				try { gtag('event', 'IgnoreAddressWarning', {'event_category': 'CheckoutSubmit'}); } catch(e) {}
				resolve(true);
			});
			this.backLink.click(this.onAnyClick.bind(this));
			this.confirmLink.click(this.onAnyClick.bind(this));
		}.bind(this)) ;
	}
	
	close() {
		this.element.css('display', 'none');
	}
	
	onAnyClick(event) {
		event.preventDefault();
		this.close();
	}
}